<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <div style="display: inline;">
      <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/wo/feeding/record/page" ref="yt" getKey="rows" :columns="columns" @afterGet="afterGet" @selectionChange="selectionChange">
        <template #conditions>
          <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
            <el-form-item :label="$t('touliaoleixing')">
              <yi_dictionary_select :type="'FEEDING_BIZ_TYPE'" :ids.sync="yt.conditions.feedingType"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('hunliaodanhao')">
              <el-input v-model="yt.conditions.mixtureOrderNo" size="mini" />
            </el-form-item>

            <el-form-item :label="$t('hunliaobiaoqianhao')">
              <el-input v-model="yt.conditions.mixTagCode" size="mini" />
            </el-form-item>

            <el-form-item :label="$t('shengchanongdanhao')">
              <el-input v-model="yt.conditions.woNo" size="mini" />
            </el-form-item>
            <el-form-item :label="$t('jihuadanhao')">
              <el-input v-model="yt.conditions.planNo" size="mini" />
            </el-form-item>
            <el-form-item :label="$t('ERPgongdanhao')">
              <el-input v-model="yt.conditions.erpWoNo" size="mini" />
            </el-form-item>
            <el-form-item :label="$t('shebeimingcheng')">
              <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('touliaoshijian')">
              <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" :maxTime="31 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.begin" :end.sync="yt.conditions.end"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('shifoutouliao')">
              <el-select v-model="yt.conditions.isOverLimit" size="mini" clearable>
                <el-option :label="$t('shi')" :value="1"></el-option>
                <el-option :label="$t('fou')" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('yuancailiaobiaoqiantiaomahao')">
              <el-input v-model="yt.conditions.labelRawMaterialsBarcode" size="mini" />
            </el-form-item>
            <el-form-item :label="$t('touliaoren')">
              <yi_data_select multiple :type="'customer_user'" :ids.sync="yt.conditions.feedingUserIds"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('touliaosuoshuriqi')">
              <yi_time_input :format="'yyyy-MM-dd'" :maxTime="90 * 24 * 3600 * 1000" type="daterange" :start.sync="yt.conditions.feedingDateBegin" :end.sync="yt.conditions.feedingDateEnd"></yi_time_input>
            </el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain size="mini">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear()" size="mini">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form>
        </template>

        <template #buttonsR>
          <el-button :loading="weight_info_export_loading" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
          <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
        </template>

        <template #tlsl="{row}">
          <span v-if="row.mixtureTagId">
            <el-button size="mini" type="text" @click="yt.showEditDialog('hunliaoBOM', row, '50%')">{{ row.feedingWeight }}</el-button>
          </span>
          <span v-else>
            {{ row.feedingWeight }}
          </span>
        </template>

        <template #danwei="{row}">
          <span v-if="row.feedingUnit">
            {{ row.feedingUnit }}
          </span>
          <span v-else>
            {{ row.material ? row.material.unit : '' }}
          </span>
        </template>
      </yi_curd_table>

      <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" dialog-scroller>
        <template v-if="yt.editObj.action === 'hunliaoBOM'">
          <div class="dialog-scroller">
            <el-row>
              <span style="font-size: 20; color: grey;"> {{ $t('hunliaogongdanhao') }}:{{ yt.editObj.mixOrder.no }}</span>
            </el-row>
            <mixtureBom :tagId="yt.editObj.id"></mixtureBom>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
const date = new Date();
const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
import XLSX from 'xlsx';

import mixtureBom from './mixture_bom';

export default {
  name: 'web_production_management_wo_feed_record',
  components: { mixtureBom },
  data() {
    return {
      weight_info_export_loading: false,
      columns: [
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no'
        },
        {
          label: 'ERPgongdanhao',
          prop: 'wo.erpNo'
        },
        {
          label: 'jihuadanhao',
          prop: 'plan.no'
        },
        {
          label: 'hunliaodanhao',
          prop: 'mixOrder.no'
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'yuancailiaobiaoqiantiaomahao',
          prop: 'labelRawMaterials.barCode'
        },
        {
          label: 'hunliaobiaoqianhao',
          prop: 'mixtureTag.labelBarcodeNumber'
        },
        {
          label: 'touliaoshijian',
          prop: 'feedingTime',
          type: 'time'
        },
        {
          label: 'touliaosuoshuriqi',
          prop: 'feedingDate',
          type: 'time',
          format: 'YYYY-MM-DD'
        },
        {
          label: 'touliaosuoshubanci',
          prop: 'feedingShift'
        },
        {
          label: 'touliaowuliaobianma',
          prop: 'material.code'
        },

        {
          label: 'touliaowuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'tlsl',
          prop: 'feedingWeight',
          type: 'slot'
        },
        {
          label: 'danwei',
          prop: 'feedingUnit',
          type: 'slot'
        },
        {
          label: 'touliaoren',
          prop: 'feedingUser.nickname'
        },
        {
          label: 'shifoutouliao',
          prop: 'isOverLimit',
          type: 'tag',
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('shi')
            },
            0: {
              color: '#67C23A',
              text: this.$t('fou')
            }
          }
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        begin: begin,
        end: end,
        feedingDateBegin: begin,
        feedingDateEnd: end
      };
      this.yt.get(1);
      this.$nextTick(() => {
        this.utils.event_hub.$emit('RESIZE');
      });
    }, 300);
  },
  methods: {
    clear() {
      this.yt.conditions = {};
      this.yt.conditions.begin = begin;
      this.yt.conditions.end = end;
      this.yt.conditions.feedingDateBegin = begin;
      this.yt.conditions.feedingDateEnd = end;
      this.yt.get(1);
    },
    exportExcel() {
      this.weight_info_export_loading = true;
      //查询表格
      this.http
        .get('/web/wo/feeding/record/page?pageNum=1&pageSize=9999', { params: { ...this.yt.conditions } })
        .then(res => {
          let tableFirst = this.columns.map(i => this.$t(i.label));
          let tableData = [];
          tableData.push(tableFirst);
          let listData = res.data.rows;
          for (let i = 0; i < listData.length; i++) {
            let dataArr = this.getTableDataArr(listData[i], tableFirst);
            tableData.push(dataArr);
          }
          const worksheet = XLSX.utils.aoa_to_sheet(tableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, `投料记录_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
        })
        .finally(() => {
          this.weight_info_export_loading = false;
        });
    },
    getTableDataArr(row, tableFirst) {
      let dataArr = [];
      dataArr[tableFirst.indexOf(this.$t('shengchangongdanhao'))] = row.wo.no;
      dataArr[tableFirst.indexOf(this.$t('ERPgongdanhao'))] = row.wo.erpNo;
      dataArr[tableFirst.indexOf(this.$t('jihuadanhao'))] = row.plan ? row.plan.no : '';
      dataArr[tableFirst.indexOf(this.$t('shebeimingcheng'))] = row.equipment.name;
      dataArr[tableFirst.indexOf(this.$t('yuancailiaobiaoqiantiaomahao'))] = row.labelRawMaterials ? row.labelRawMaterials.barCode : '';
      dataArr[tableFirst.indexOf(this.$t('touliaoshijian'))] = row.feedingTime && this.dayjs(row.feedingTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[tableFirst.indexOf(this.$t('chanpinbianma'))] = row.material.code;
      dataArr[tableFirst.indexOf(this.$t('chanpinmingcheng'))] = row.material.name;
      dataArr[tableFirst.indexOf(this.$t('tlsl'))] = row.feedingWeight;
      dataArr[tableFirst.indexOf(this.$t('touliaoren'))] = row.feedingUser ? row.feedingUser.nickname : '';
      dataArr[tableFirst.indexOf(this.$t('shifoutouliao'))] = row.isOverLimit === 1 ? '是' : '否';
      return dataArr;
    }
  }
};
</script>
